import { useEffect } from "react";
import './Enterprise.css';
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer"; 
import { useNavigate, useLocation } from "react-router-dom";
 
const Enterprise = ()=> {


    const navigate = useNavigate();
    const location = useLocation();

       // Function to handle navigation
       const handleNavigation = (section) => {
        if (location.pathname !== "/") {
            navigate("/", { state: { scrollTo: section } });
        } else {
            scrollToSection(section);
        }
    };

     // Function to scroll to section
     const scrollToSection = (section) => {
        setTimeout(() => {
            const element = document.getElementById(section);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 300);
    };

       
       useEffect(() => {
        if (location.state?.scrollTo) {
            scrollToSection(location.state.scrollTo);
        }
    }, [location]);


    return (
        <>
            <AIheader/>

            {/* START enterpriseBannerMain */}
            <section className='enterpriseBannerMain'>
                <div className='enterpriseBannerOuter'>
                    <div className='container-fluid'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                <div className='enterpriseBannerInner'>
                                    <h1><img className='img-fluid' src="/img/Technology/rentid_logo_white.svg" alt="rent id"/> Enterprice</h1>
                                    <h2>Build Your Own Car Rental<br/> Ecosystem with Rentid APIs</h2>
                                    <p>Power your business with  rental workflows, automated ID verification, and embedded insurance.</p>
                                    <a className="btn btnGreen" href="/contact-sales">Contact Sales</a>
                                </div>
                                <div className='enterpriseBannerList'>
                                    <ul>
                                        <li>
                                            <img src="/img/Pricing/check_green.svg" alt="check"/>
                                            Integrate fast — no limitations.
                                        </li>
                                        <li>
                                            <img src="/img/Pricing/check_green.svg" alt="check"/>
                                            Control pricing, logic, and flows.
                                        </li>
                                        <li>
                                            <img src="/img/Pricing/check_green.svg" alt="check"/>
                                            Built to scale with your business.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END enterpriseBannerMain */}
  
 
            {/* STRAT intProductsMain */}
            <section className='intProductsMain'>
                <div className='intProductsOuter'>
                    <div className='container'>
                        {/* row start */}
                        <div className="row">
                            <div className="col-lg-9 col-md-9 col-sm-12">
                                <div className="intProductsHeading">
                                    <small>INTEGRATION PRODUCTS</small>
                                    <h2>The Rentid Enterprise API Suite</h2>
                                    <p>Rental products that put your enterprise in the driver seat</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12">
                                <div className="intProductsBtn">
                                    <a className="btn" href="/contact-sales">Contact Sales</a>
                                </div>
                            </div>
                        </div> 
                        <div className="row justify-content-center">
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div className="intProductsInner">
                                    <figure>
                                        <img className="img-fluid" src="/img/Enterprise/rent_direct.svg" alt="blog"/>
                                    </figure>
                                    <div className="intProductsData">
                                        <h3>Rental Management Lifecycle</h3>
                                        <p>Build a fully customized rental service that<br/> supports your needs.</p>
                                        <ul>
                                            <li><span>Real-time Booking Management:</span> Control availability, pricing, and rental durations.</li>
                                            <li><span>Fleet & Inventory Automation:</span> Manage vehicle assignments, status, and locations.</li>
                                            <li><span>Custom Checkout & Payment Processing:</span> Integrate with your existing systems.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div className="intProductsInner">
                                    <figure>
                                        <img className="img-fluid" src="/img/Enterprise/rent_id.svg" alt="blog"/>
                                    </figure>
                                    <div className="intProductsData">
                                        <h3>Trust & Safety Workflows & Tools</h3>
                                        <p>Seamlessly verify renters with AI-powered <br/>ID authentication and risk assessment.</p>
                                        <ul>
                                            <li><span>Instant Identity Verification:</span> Authenticate renter selfies & documents using AI. </li>
                                            <li><span>Driver Insurance Validation:</span> Reduce fraud, ensure compliance, with active monitoring.</li>
                                            <li><span>Driver Risk Score & Block List:</span> Assess renter reliability before granting access.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div className="intProductsInner">
                                    <figure>
                                        <img className="img-fluid" src="/img/Enterprise/rent_shield.svg" alt="blog"/>
                                    </figure>
                                    <div className="intProductsData">
                                        <h3>Embedded Insurance & Protection</h3>
                                        <p>Built-in protection for every rental with <br/>on-demand, rental insurance.</p>
                                        <ul>
                                            <li><span>Instant Coverage Activation:</span> Bind coverage dynamically at the time of rental.</li>
                                            <li><span>Flexible Plans:</span> Liability-only or full coverage options for your fleet.</li>
                                            <li><span>Seamless Claims Integration:</span> Automate damage and loss reporting. </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END intProductsMain */}


            {/* STRAT oneApiMain */}
            <section className='oneApiMain'>
                <div className="oneApiOuter">
                    <div className='container'>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-lg-6">
                                <div className="oneApiLeft">
                                    <figure>
                                        <img className='img-fluid' src="/img/Enterprise/oneApi_1.png" alt="rent id"/>
                                    </figure>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="oneApiRight">
                                    <h2>One solution. <br/>Full control over<br/> 
                                    automation, protection,<br/> 
                                    and guest experience—<br/>on your terms.</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END oneApiOuter */}


            {/* START rentalSuitMain */}
            <section className="rentalSuitMain">
                <div className="rentalSuitOuter"> 
                    <div className="container">  
                        <div className="rentalSuitInner"> 
                            <div className='row align-items-center'>
                                <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                    <div className='rentalSuitLeft'>
                                        <h2>Rental Suite Designed to <br/>Solve Enterprise Challenges</h2>
                                        <p>Easily integrate our full or partial rental suite into your 
                                        existing tech stack—web apps, native apps, third-party platforms, 
                                        or anything else.</p>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                    <div className='rentalSuitRight'>
                                        <figure>
                                            <img src="/img/Enterprise/rentalSuit_1.svg" alt="rent id"/>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END rentalSuitMain */}
 

            {/* STRAT thatScaleMain */}
            <section className='thatScaleMain'>
                <div className='thatScaleOuter'>
                    <div className='container'>
                        {/* row start */} 
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="thatScaleHeading">
                                    <small>RENTAL SOLUTIONS</small>
                                    <h2>Solutions that scale </h2>
                                    <p>From startups to national fleets, Rentid’s modular 
                                    suite adapts to your operation. Build faster, scale 
                                    smarter, and stay in control at every stage.</p>
                                </div>
                            </div>
                        </div>
                        {/* row END */} 
                        
                        {/* row start */} 
                        <div className="row justify-content-center">
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div className="thatScaleInner">
                                    <figure>
                                        <img className="img-fluid" src="/img/Enterprise/car_1.svg" alt="RENTAL SOLUTIONS"/>
                                    </figure> 
                                    <h3>Reimagine How Rentals Work</h3>
                                    <p>Automate everything from guest <br/>
                                    screening to on-rent protection—all <br/>
                                    through one flexible API suite.</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div className="thatScaleInner">
                                    <figure>
                                        <img className="img-fluid" src="/img/Enterprise/flow_1.svg" alt="RENTAL SOLUTIONS"/>
                                    </figure> 
                                    <h3>Own Your Entire Rental Flow</h3>
                                    <p>From booking to key handoff, take full<br/> control of the guest experience—no <br/>
                                    third-party limitations, no interference.</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div className="thatScaleInner">
                                    <figure>
                                        <img className="img-fluid" src="/img/Enterprise/money_1.svg" alt="RENTAL SOLUTIONS"/>
                                    </figure> 
                                    <h3>From Fleets to Profits</h3>
                                    <p>Increase vehicle utilization with built-in <br/>upsells, protection options, and verified <br/>
                                    guest access—all optimized for revenue <br/> growth.</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div className="thatScaleInner">
                                    <figure>
                                        <img className="img-fluid" src="/img/Enterprise/brain_1.svg" alt="RENTAL SOLUTIONS"/>
                                    </figure> 
                                    <h3>Build Smarter, Not Slower</h3>
                                    <p>Connect Rentid to your existing systems <br/>in days, not months. Our modular 
                                    architecture is dev-friendly and endlessly<br/> scalable.</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div className="thatScaleInner">
                                    <figure>
                                        <img className="img-fluid" src="/img/Enterprise/connect_1.svg" alt="RENTAL SOLUTIONS"/>
                                    </figure> 
                                    <h3>Stay in Sync, Always</h3>
                                    <p>Power high-volume operations with real-<br/> time data syncing, 99.9% uptime, and <br/>
                                    intelligent routing that keeps your fleet <br/>optimized.</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div className="thatScaleInner">
                                    <figure>
                                        <img className="img-fluid" src="/img/Enterprise/rainbow_1.svg" alt="RENTAL SOLUTIONS"/>
                                    </figure> 
                                    <h3>No Tech Debt, All Ambition</h3>
                                    <p>Eliminate clunky tools and  <br/>fragmented systems. We <br/>
                                    handles the rental <br/> infrastructure so your team can <br/>
                                    focus on building for the future</p>
                                </div>
                            </div>
                        </div>
                        {/* row END */} 
                    </div>
                </div>
            </section>
            {/* END thatScaleMain */}



            {/* STRAT altSolutionsMain */}
            <section className='altSolutionsMain'>
                <div className='altSolutionsOuter'>
                    <div className='container'>
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="altSolutionsHead">
                                    <h2>Alternative solutions for your business</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <div className="altSolutionsInner altSolutionsInner_1">
                                    <a href="/platform">
                                        <div className="techHeading">
                                            <h3>Platform</h3>
                                        </div>
                                        <div className="altSolutionsData">
                                            <figure>
                                                <img className="img-fluid" src="/img/Technology/platform_icon.svg" alt="rent id"/>
                                            </figure>
                                            <div className="altSolutionsDataRight">
                                                <p>From on-board to on-rent<br/> in less than 60 minutes,<br/> all in one place.</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <div className="altSolutionsInner altSolutionsInner_2">
                                    <a href="/marketplace">
                                        <div className="techHeading">
                                            <h3>Marketplace</h3>
                                        </div>
                                        <div className="altSolutionsData">
                                            <figure>
                                                <img className="img-fluid" src="/img/Technology/map_icon.svg" alt="rent id"/>
                                            </figure>
                                            <div className="altSolutionsDataRight">
                                                <p>Your rental brand<br/> accessible to renters<br/> anywhere & everywhere.</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                        </div> 
                    </div>
                </div>
            </section>
            {/* END altSolutionsMain */}

            {/* START helpPeopleMain */} 
            <section className='helpPeopleMain'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className='helpPeopleInner'>
                                <h2>Let’s help <span>people</span> get <br/>to their destination <br/><span>safely and conveniently.</span></h2>
                                <div className='helpPeopleBtn'>
                                    <a className="btn btnWhiteSpl" href="/contact-sales">Contact Sales
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END helpPeopleMain */}

            <Footer/>
        </>
    )
}

export default Enterprise;